import { env } from '@/env'
import { api } from '@/services/fintalk/api'
import { FeatureFlag } from '@/stores/use-feature-flags'

export type FeatureFlagApiKey = keyof typeof FeatureFlag

export interface GetFeatureFlagsResponse {
  flags: Partial<Record<FeatureFlagApiKey, boolean>>
}

export async function getFeatureFlags(): Promise<GetFeatureFlagsResponse> {
  const resp = await api.get<GetFeatureFlagsResponse>(
    env.VITE_FINTALK_BACKOFFICE_URL,
    '/feature-flags',
  )

  return resp.body
}
